import { render } from "./ListRoute.vue?vue&type=template&id=2355f1e2&scoped=true"
import script from "./ListRoute.vue?vue&type=script&lang=js"
export * from "./ListRoute.vue?vue&type=script&lang=js"

import "./ListRoute.vue?vue&type=style&index=0&id=2355f1e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2355f1e2"]])

export default __exports__